module.exports = __webpack_public_path__ + "static/media/pic1.2d05a71f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assests/images/pic1.jpg
// module id = 116
// module chunks = 0